import { OidcClient, UserManager } from 'oidc-client-ts';

export const signIn = (userManager: UserManager) => {

    userManager.signinRedirect();
}